module.exports = __webpack_public_path__ + "static/media/sofa-1.e3c46c4e.webp";